import { Link as RemixLink } from "@remix-run/react";
import { Text, Button } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";

import { useUserSubscriptionValue } from "#app/hooks/index.js";
import { AvailabilityRequestLimitDetails } from "#app/components/index.jsx";
import { isFreeAccessFacility } from "#app/config/freeAccessOffers.js";

export const useHelpTextComponent = ({ facility } = {}) => {
  // Free-access facilities don't consume a cap slot, so the limit warning
  // is misleading on those forms — the user can submit even at cap. The
  // FreeAccessAlert above the form already explains the situation.
  const isFreeAccess = isFreeAccessFacility(facility);

  return useUserSubscriptionValue({
    none: () => (
      <Text color="muted" fontSize="sm">
        Already have an account? Be sure to{" "}
        <Button
          variant="link"
          colorScheme="brand"
          size="sm"
          rightIcon={<ArrowForwardIcon />}
          as={RemixLink}
          to="/login"
        >
          log in
        </Button>
      </Text>
    ),
    trial: () =>
      isFreeAccess ? null : (
        <AvailabilityRequestLimitDetails
          limitText="You've reached your request limit. "
          limitTextProps={{ color: "warning" }}
        />
      ),
    active: () =>
      isFreeAccess ? null : (
        <AvailabilityRequestLimitDetails
          limitText="You've reached your request limit. "
          limitTextProps={{ color: "warning" }}
        />
      ),
  });
};
